import { Core } from "@/core/Core";

const NA0_BASE_URL = "https://api.ishopfood.com";
const NA1_BASE_URL = "https://na1-api.ishopfood.com";

// Maps an explicit region selection to a hard-coded API base URL.
// `null` means the user picked Default — handled separately so it can fail
// over from NA0 to NA1 when running against the prod build.
function regionBaseUrl(region) {
  if (region === "na0") return NA0_BASE_URL;
  if (region === "na1") return NA1_BASE_URL;
  return null;
}

// True when the build is pointed at a prod-style API host (api.ishopfood.com).
// In dev / local the failover doesn't apply; we just hit Parameters.urlServer.
function isProdBuild() {
  let url = (typeof Parameters !== "undefined" && Parameters.urlServer) || "";
  return /(^|\/\/)(?:[^\/]*\.)?ishopfood\.com(?::|\/|$)/i.test(url);
}

function postLogin(payload, baseUrl) {
  let options = {ignoreToken: true};
  if (baseUrl) {
    options.baseUrl = baseUrl;
  }
  return Core.request("POST", "/api/login2?augment=admin", payload, options);
}

export default {

  async login(context, {username, password, superAdminToken, region}) {
    let payload = {username, password, superAdminToken, branch: null};

    // Explicit region selection: one attempt against that cluster, no failover.
    let explicit = regionBaseUrl(region);
    if (explicit) {
      try {
        return await postLogin(payload, explicit);
      } catch (e) {
        return new Core.Error(e);
      }
    }

    // Default selector on dev / local: no failover, use the build-time host.
    if (!isProdBuild()) {
      try {
        return await postLogin(payload, null);
      } catch (e) {
        return new Core.Error(e);
      }
    }

    // Default selector on prod: try NA0 first, fall back to NA1 on any error
    // (auth failure, server error, network error). If NA1 also fails, surface
    // the NA1 error so the user sees the actual final failure.
    try {
      return await postLogin(payload, NA0_BASE_URL);
    } catch (na0Error) {
      try {
        return await postLogin(payload, NA1_BASE_URL);
      } catch (na1Error) {
        return new Core.Error(na1Error);
      }
    }
  },

  async superAdminContextLogin(context, {username, branch}) {
    try {
      return await Core.request("POST", "/api/context-login", {username, branch});
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async adminPasswordReset(context, {email, branch, locale}) {
    try {
      return await Core.request("POST", "/api/admin-reset-password", {email, branch});
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async adminHardEditUsername(context, {username, newUsername, branch}) {
    try {
      return await Core.request("POST", "/api/admin-hard-edit-username", {username, newUsername, branch});
    } catch (e) {
      return new Core.Error(e);
    }
  },



  async forgotPassword(context, {email, locale, redirect_url}) {
    try {
      return await Core.request("POST", "/api/forgot_password/", {email, locale, redirect_url});
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async resetPassword(context, {token, password}) {
    try {
      return await Core.request("POST", "/api/forgot_password/" + token, {password});
    } catch (e) {
      return new Core.Error(e);
    }
  }

}